import Vue from 'vue';
import Component from 'vue-class-component';
import { EdContextMenuModel, EdContextMenuOptionsModel } from '@/plugins/ed-context-menu/ed-context-menu.plugin';
import { Prop } from 'vue-property-decorator';
import KEYS from '@/values/keys';

@Component({
  name: 'ed-header-sidebar-menu'
})
export default class EdHeaderSidebarMenu extends Vue {

  public toggleSidebar() {
    this.$App.Store.toggleSidebar()
  }

}